import { Language } from './Language';

export class en implements Language{

    //----------Connect----------//
    //UserActions
    UserActionsRef = "Reference";
    UserActionsDateSend = "Send date";
    UserActionsDateDownload = "Download date";
    UserActionsObservation = "Observation";
    UserActionsName = "Name";
    UserActionsID = "Index";
    UserActionsStatus = "Status";
    UserActionsComment = "Comment";
    //Login
    LoginWelcome = "Welcome on Fives Solios INC portal";
    LoginMailValid = "Valid mail required";
    LoginMailRequired = "Mail id required";
    LoginPasswordRequired = "Password required";
    LoginTitle = "Document portal";
    LoginID = "ID";
    LoginPassword = "Password";
    LoginConnect = "Sign in";

    //----------Components----------//
    //BoxModule
    BoxModuleLoad = "Loading...";
    BoxModuleAlt = "module's logo";
    BoxModuleSingular = "document";
    BoxModulePlural = "documents";
    //DisplayDocs
    DisplayDocsName = "name";
    DisplayDocsCreation = "creation date"
    DisplayDocsRecipient = "recipient";
    DisplayDocsAuthor = "author";
    DisplayDocsContract = "contract";
    //ExternalDocModal
    ExternalDocModalReceive = "Receive";
    //MyModal
    MyModalApproved = "Approved";
    MyModalApprovedWithComment = "Approved with comment";
    MyModalReceiveTitle = "Send a reception comment";
    MyModalReceiveWarning = "Beware, by approving/refusing this collection,";
    MyModalReceiveWarning2 = "you approve/refuse all the documents it contains";
    MyModalComments = "Comment(s)";
    MyModalInProgress = "In progress ";
    MyModalApprove = "Approve";
    MyModalApproveComment = "Approve with comment";
    MyModalReject = "Refuse";
    MyModalCancel = "Cancel";
    MyModalExternalInProgress = "In progress ";
    MyModalExternalApprove = "Approve";
    MyModalExternalApproveComment = "Approve with comment";
    MyModalExternalReject = "Refuse";
    MyModalExternalCancel = "Cancel";
    MyModalReceivedTitle = "Client feedback";
    MyModalReceivedStatus = "Client status :";
    MyModalReceivedDate = "Feedback date :";
    MyModalReceivedRole = "Feedback made by :";
    MyModalReceivedComments = "Comment(s)";
    MyModalReceivedClose = "Close";
    MyModalReceivedRefused = "Rejected";
    MyModalFile = "Choose Files";
    MyModalFileEmpty = "No file chosen";
    MyModalFileSingular = "file";
    MyModalFilePlural = "files";
    //RecepModal
    RecepModalReceive = "Receive";
    //SendNewDocModal
    SendNewDocModalModify = "Modify";
    SendNewDocModalSend = "Send a new document";
    //ExpandedDataTable
    ExpandedDataTableTitle = "My documents : "
    ExpandedDataTableNoDocument = "No document";
    //MyDataTable
    MyDataTableProgress = "In progress ";
    MyDataTableReceived = "Received";
    MyDataTableDownloading = "Download in progress ";
    MyDataTableDownload = "Download";
    MyDataTableNoData = "No corresponding data";
    MyDataTableSelected = "selected collection";
    MyDataTableSelectedPlural = "selected collections";
    MyDataTableSeparator = "of";
    //Navbar
    NavbarHomepage = "Homepage";
    NavbarReceive = "Receive documents";
    NavbarSending = "Send documents";
    NavbarExternal = "External documents";
    NavbarPolicy = "Fives policy";
    NavbarDisconnect = "Disconnect";
    NavbarFirst = "First connection : choose a new password";
    //Report
    ReportTitle = "Fives - Document Portal";
    ReportProblem = "Report a problem";

    //----------Pages----------//
    //ExternalDocs
    ExternalDocsTitle = "External documents";
    ExternalDocsLoad = "Loading documents...";
    //Home
    HomeSee = "View";
    HomeReceiveName = "Receive documents";
    HomeReceiveDesc = "Diffusions to download";
    HomeSendName = "Send documents";
    HomeSendDesc = "New diffusion(s) of document(s)";
    HomeAccountName = "My account";
    HomeAccountDesc = "Change your password";
    HomePolicyName = "Fives policy";
    HomePolicyDesc = "Policy regarding personal data";
    //ModifyPassword
    ModifyPasswordActual = "Current password";
    ModifyPasswordActualText = "Enter your current password";
    ModifyPasswordNew = "New password";
    ModifyPasswordNewText = "Enter your new password";
    ModifyPasswordConfirm = "Confirm";
    ModifyPasswordConfirmText = "Re-enter your new password";
    ModifyPasswordErrorDiff = "The passwords are differents";
    ModifyPasswordErrorInvalid = "The password must contains at least ";
    ModifyPasswordErrorInvalid2 = " characters, a lowercase, an uppercase, a number and a special character";
    ModifyPasswordErrorIncorrect = "Current password invalid";
    ModifyPasswordSuccess = "Password changed successfully";
    //MyAccount
    MyAccountChange = "Change my password";
    //RecepDocs
    RecepDocsRecipient = "Recipient : ";
    RecepDocsContracts = "Contracts";
    RecepDocsContractsAll = "All";
    RecepDocsContractsUpToDate = "Contracts up-to-date";
    RecepDocsContractsLoad = "Loading recents contracts...";
    RecepDocsCollection = "My collections";
    RecepDocsCollectionUpToDate = "Collections up-to-date";
    RecepDocsCollectionLoad = "Loading recents collections...";
    RecepDocsCollectionLoad2 = "Loading collections";
    RecepDocsShow = "Display";
    RecepDocsShowAll = "All collections";
    RecepDocsShowUndownloaded = "Not downloaded";
    RecepDocsShowRadio = "Only show collections with documents not yet received";
    RecepDocsSearch = "Search";
    RecepDocsRefresh = "Refresh";
    //HeaderSendDocs
    HeaderSendDocsSender = "Sender : "; 
    HeaderSendDocsInfo = "Informations";
    //MyBroadcasts
    MyBroadcastsInternalID = "Internal ID";
    MyBroadcastsName = "File Name";
    MyBroadcastsID = "Index";
    MyBroadcastsStatus = "Status";
    MyBroadcastsComment = "Comment";
    MyBroadcastsShow = "Show archived documents";
    MyBroadcastsSearch = "Search...";
    MyBroadcastsLoad = "Loading all documents...";
    MyBroadcastsLoad2 = "Loading documents...";
    MyBroadcastsRefresh = "Refresh";
    MyBroadcastsTitle = "Sent documents";
    //SendNewDoc
    SendNewDocModified = "Document modified successfully";
    SendNewDocSent = "Document sent successfully";
    SendNewDocError = "Invalid document, check the file extension (valid extensions : pdf, xlsx, xls)";
    SendNewDocModifying = "Modifying ";
    SendNewDocSending = "Sending ";
    SendNewDocModify = "Modify";
    SendNewDocSend = "Send a new document";
    SendNewDocNotSupported = "Data type not supported";
    SendNewDocIndex = "Index";
    SendNewDocStatus = "Status";
    SendNewDocComment = "Comment";
    SendNewDocFile = "Choose Files";
    SendNewDocFileEmpty = "No file chosen";
    SendNewDocFileSingular = "file";
    SendNewDocFilePlural = "files";
    //SwitchPage
    SwitchPagePassword = "Change my password";
    SwitchPageDisconnect = "Disconnect";

    //----------Public----------//
    //AuthentificationChoice
    AuthentificationChoiceMail = "Receive a mail";
    AuthentificationChoiceSMS = "Receive a SMS";
    //EnterMail
    EnterMailError = "Error while sending. The link used to reach the page may have expired.";
    EnterMailAddress = "Enter your email address";
    EnterMailSend = "Send";
    EnterMailBack = "Back";
    //MyTimer
    MyTimerExpired = "The code has expired";
    //Public
    PublicQuestion = "How do you want to receive your temporary code ?";
    //PublicDatatableCollections
    PublicDatatableCollectionsRef = "Reference";
    PublicDatatableCollectionsDateSend = "Send date";
    PublicDatatableCollectionsDateDownload = "Download date";
    PublicDatatableCollectionsObservation = "Observation";
    PublicDatatableCollectionsSearch = "Search";
    PublicDatatableCollectionsTitle = "My collections";
    //SendingCode
    SendingCodeInProgress = "Sending of ";
    SendingCodeInProgress2 = " in progress ";
    //SuccessDownload
    SuccessDownloadSuccess = "Download successful";
    SuccessDownloadBack = "Return to the homepage";
    //WaitingForCode
    WaitingForCodeSent = "If the entered email address exists, an email have been sent to it.";
    WaitingForCodeTimer = "You have 10 minutes to enter the code received by ";
    WaitingForCodeChecking = "Code checking in progress...";
    WaitingForCodeError = "Code invalid, expired or already used";
    WaitingForCodeCheck = "Check";
    WaitingForCodeBack = "Back";

    //----------WebApi----------//
    //WebApi
    WebApiErrorBadRequest = "Bad request";
    WebApiErrorRights = "You don't have the rights to send a document";
    WebApiErrorInvalid = "Invalid document, check the file extension (valid extensions : pdf, xlsx)";

    //RecoilApp
    RecoilAppConnection = "Connection in progress...";
}